import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
	MatterManualTitleInsurance,
	TitleInsuranceCredit,
	TitleInsuranceFee,
} from '@models/title-insurance';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable } from 'rxjs';

export interface FCTTitleInsuranceCostBreakdownData {
	type: 'ORDER' | 'QUOTE';
}

@UntilDestroy()
@Component({
	selector: 'app-cost-breakdown',
	templateUrl: './cost-breakdown.component.html',
	standalone: false,
})
export class CostBreakdownComponent implements OnInit {
	public titleInsurance: MatterManualTitleInsurance;
	public total = 0;
	public totalAmount = 0;
	public totalTax = 0;
	public afterCredit = 0;

	public fees: TitleInsuranceFee[] = [];
	public credits: TitleInsuranceCredit[] = [];

	public counselCredit;

	public separateTaxes = false;

	@Select(SelectedMatter.getTitleInsurance)
	titleInsurance$: Observable<MatterManualTitleInsurance>;

	constructor(
		private dialogRef: MatDialogRef<CostBreakdownComponent>,
		@Inject(MAT_DIALOG_DATA) public _data: FCTTitleInsuranceCostBreakdownData,
	) {}

	ngOnInit(): void {
		this.titleInsurance$
			.pipe(untilDestroyed(this))
			.subscribe((_titleInsurance) => {
				this.separateTaxes = _titleInsurance.companyName === 'Chicago';
				if (!this._data?.type || this._data?.type === 'ORDER') {
					this.totalAmount = _titleInsurance?.fees.reduce(
						(prev, curr) => prev + this.getAmount(curr.amount),
						0,
					);
					this.totalTax = this.getAmount(this.separateTaxes)
						? _titleInsurance.totalTax
						: _titleInsurance?.fees.reduce(
								(prev, curr) => prev + this.getAmount(curr.tax),
								0,
							);
					this.total = _titleInsurance?.fees.reduce(
						(prev, curr) => prev + this.getAmount(curr.total),
						0,
					);
					this.fees = _titleInsurance?.fees;
					this.credits = _titleInsurance?.credits.map((credit) => ({
						...credit,
						description: credit.description,
						amount: Math.abs(credit.amount),
						total: Math.abs(credit.total),
					}));
					this.afterCredit = this.getAmount(
						_titleInsurance.premiumWithCounselCreditApplied,
					);
				} else if (_titleInsurance?.quote) {
					this.totalAmount = _titleInsurance.quote?.fees?.reduce(
						(prev, curr) => +prev + this.getAmount(curr.amount),
						0,
					);
					this.totalTax = _titleInsurance.quote?.fees?.reduce(
						(prev, curr) => +prev + this.getAmount(curr.tax),
						0,
					);
					this.total = _titleInsurance.quote?.fees?.reduce(
						(prev, curr) => +prev + this.getAmount(curr.total),
						0,
					);
					this.fees = _titleInsurance?.quote?.fees;
					this.credits = _titleInsurance?.quote?.credits;
					this.afterCredit = this.getAmount(
						_titleInsurance?.quote?.premiumWithCounselCreditApplied,
					);
				}
			});
	}

	close() {
		this.dialogRef.close();
	}

	getAmount(amount): number {
		return +(amount ?? 0);
	}
}
